module.exports = __webpack_public_path__ + "img/user24.5fd6bc04.jpg";